<template>
  <div class="wt2-sg wt2-masthead-menu">
    <wt-dropdown-view type="right" :disabled="disabled">
      <template slot="label">
        <i class="wticon wticon-hamburger3" />
      </template>
      <template slot="view">
        <ul class="-menu-options">
          <li v-if="show.story && isUserCanCreateStories">
            <span
              @click="justDoIt"
              data-trigger="app.menu.command"
              data-trigger-data="DELETE"
            >
              <i class="wticon wticon-trash2" />
              <span class="wt-menu-text">{{
                'mastheadMenu.deleteVideo' | culture
              }}</span>
            </span>
          </li>
          <li v-if="show.story && isUserCanCreateStories">
            <span
              @click="justDoIt"
              data-trigger="app.menu.command"
              data-trigger-data="COPY_DRAFT_TO_DRAFT"
            >
              <i class="wticon wticon-duplicate" />
              <span class="wt-menu-text">{{
                'mastheadMenu.makeCopy' | culture
              }}</span>
            </span>
          </li>
          <!-- <li v-if="show.story && !isStoryboard">
            <span
              @click="justDoIt"
              data-trigger="app.menu.command"
              data-trigger-data="TRANSLATE"
            >
              <i class="wticon wticon-translate" />
              <span class="wt-menu-text">Translate</span>
              <span class="-beta wt2-text-s">Beta</span>
            </span>
          </li> -->
          <li
            v-if="show.story && isUserCanCreateStories && !isImpededTemplatizer"
          >
            <span
              @click="justDoIt"
              data-trigger="app.menu.command"
              :data-trigger-data="
                isStoryboard ? 'UNSET_TEMPLATE' : 'SET_AS_TEMPLATE'
              "
            >
              <i class="wticon wticon-template" />
              <span class="wt-menu-text" v-if="!isStoryboard">{{
                'mastheadMenu.setAsStoryTemplate' | culture
              }}</span>
              <span class="wt-menu-text" v-if="isStoryboard">{{
                'mastheadMenu.unsetAsStoryTemplate' | culture
              }}</span>
            </span>
          </li>
          <li v-if="showVersionHistory">
            <span
              class="-version-history"
              @click="justDoIt"
              data-trigger="app.menu.command"
              data-trigger-data="VERSION_HISTORY"
            >
              <i class="wticon wticon-clock3 wt2-color-primary" />
              <span class="wt-menu-text wt2-color-primary">{{
                'storyVersions.versionHistory' | culture
              }}</span>
              <span class="-version-count" v-text="versionsCountLabel" />
            </span>
          </li>
          <li v-if="show.story" class="-divider" />
          <li v-if="show.story">
            <span @click="justDoIt" data-trigger="app.exit">
              <i class="wticon wticon-exit-left" />
              <span class="wt-menu-text">{{
                'masthead.exitStory' | culture
              }}</span>
            </span>
          </li>
          <li
            v-if="show.story && showExpandCollapse && isExpend"
            class="-divider"
          />
          <!--// -->
          <li
            v-if="shouldShow(show.devLinks)"
            @click="justDoIt"
            data-goto="/style-guide"
          >
            <span class="wt-menu-text">Style Guide</span>
          </li>
          <li
            v-if="shouldShow(show.devLinks)"
            @click="justDoIt"
            :data-goto="apiUrl + '/resources/swagger-docs/index.html'"
          >
            <span class="wt-menu-text">Swagger UI</span>
          </li>
          <li
            v-if="shouldShow(show.devLinks)"
            @click="justDoIt"
            data-trigger="app.remoteStash.clear"
          >
            <span class="wt-menu-text">Clear Remote Stash</span>
          </li>
          <template v-if="shouldShow(show.importExport)">
            <li
              v-if="show.story"
              @click="justDoIt"
              data-trigger="app.story.export"
            >
              <span class="wt-menu-text">Export</span>
            </li>
            <li v-else @click="justDoIt" data-trigger="app.story.import">
              <span class="wt-menu-text">Import</span>
            </li>
          </template>
          <li
            v-if="shouldShow(show.devLinks) || shouldShow(show.importExport)"
            class="-divider"
          />
          <!--// -->
          <li v-if="shouldShow(show.invite)">
            <span @click="justDoIt" data-trigger="app.dashboard.invite">
              <i class="wticon wticon-paper-plane" />
              <span class="wt-menu-text">{{
                'masthead.invite' | culture
              }}</span>
            </span>
          </li>
          <li v-if="shouldShow(!isImpededTemplatizer)">
            <span @click="justDoIt" data-trigger="app.dashboard.settings">
              <i class="wticon wticon-cog" />
              <span class="wt-menu-text">{{
                'masthead.settings' | culture
              }}</span>
            </span>
          </li>
          <li v-if="shouldShow(true)">
            <span @click="$_openSupport">
              <i class="wticon wticon-help-alt wt2-color-primary" />
              <span class="wt-menu-text wt2-color-primary">{{
                'masthead.help' | culture
              }}</span>
            </span>
          </li>
          <li v-if="shouldShow(true)" class="-divider" />
          <li v-if="shouldShow(!isImpededTemplatizer)">
            <span @click="justDoIt" data-trigger="app.logout">
              <i class="wticon wticon-menu-logout" />
              <span class="wt-menu-text">{{
                'masthead.logout' | culture
              }}</span>
            </span>
          </li>
          <li v-if="showExpandCollapse" class="-divider" />
          <li class="-expend-collapse" v-if="showExpandCollapse">
            <span @click="toggle">
              <i
                class="wticon"
                :class="isExpend ? 'wticon-Expand8' : 'wticon-collapse8'"
              />
            </span>
          </li>
        </ul>
      </template>
    </wt-dropdown-view>
  </div>
</template>

<script>
import Vue from 'vue';
import MastheadMenuCore from './MastheadMenuCore';

export default Vue.extend({ ...MastheadMenuCore });
</script>
